import { render, staticRenderFns } from "./CalendarWeeklyBookings.vue?vue&type=template&id=2b67acca&scoped=true"
import script from "./CalendarWeeklyBookings.vue?vue&type=script&lang=js"
export * from "./CalendarWeeklyBookings.vue?vue&type=script&lang=js"
import style0 from "./CalendarWeeklyBookings.vue?vue&type=style&index=0&id=2b67acca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67acca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b67acca')) {
      api.createRecord('2b67acca', component.options)
    } else {
      api.reload('2b67acca', component.options)
    }
    module.hot.accept("./CalendarWeeklyBookings.vue?vue&type=template&id=2b67acca&scoped=true", function () {
      api.rerender('2b67acca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Calendar/CalendarWeeklyBookings.vue"
export default component.exports